(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (() => {
    const showDiscountConfirmation = () => {
      const confirmation = document.querySelector('[data-discount-confirmation]');

      if (!confirmation) return;

      const params = new URLSearchParams(window.location.search);
      const appliedCode = params.get('discount_applied');
      const expectedCode = confirmation.dataset.discountCode;

      if (!appliedCode || !expectedCode) return;
      if (appliedCode.toLowerCase() !== expectedCode.toLowerCase()) return;

      const fallbackMessage = `Discount code ${expectedCode} is ready and will apply at checkout.`;
      const configuredMessage = confirmation.dataset.confirmationMessage || fallbackMessage;
      const confirmationText = confirmation.querySelector('[data-discount-confirmation-text]');
      const closeButton = confirmation.querySelector('[data-discount-confirmation-close]');
      let hideTimer;

      const hideConfirmation = () => {
        confirmation.classList.remove('is-visible');

        window.setTimeout(() => {
          confirmation.hidden = true;
        }, 180);
      };

      if (confirmationText) {
        confirmationText.textContent = configuredMessage.replace('[code]', expectedCode);
      }

      confirmation.hidden = false;
      window.requestAnimationFrame(() => {
        confirmation.classList.add('is-visible');
      });

      hideTimer = window.setTimeout(hideConfirmation, 5200);

      if (closeButton) {
        closeButton.addEventListener(
          'click',
          () => {
            window.clearTimeout(hideTimer);
            hideConfirmation();
          },
          { once: true }
        );
      }
    };

    const copyText = async (text) => {
      if (!text) return false;

      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }

      const input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.top = '-9999px';
      document.body.appendChild(input);
      input.select();

      const copied = document.execCommand('copy');
      document.body.removeChild(input);

      return copied;
    };

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-announcement-copy]');

      if (!button) return;

      const message = button.querySelector('.announcement-bar__message');
      const label = button.querySelector('.announcement-bar__copy-label');
      const defaultLabel = label ? label.textContent : '';

      try {
        const copied = await copyText(button.dataset.discountCode);

        if (copied && message) {
          button.classList.add('has-message');
          message.textContent = button.dataset.copiedMessage || 'Code copied!';
          message.classList.add('is-visible');

          window.setTimeout(() => {
            message.classList.remove('is-visible');
            message.textContent = '';
            button.classList.remove('has-message');
          }, 1800);
        }
      } catch (error) {
        if (message) {
          button.classList.add('has-message');
          message.textContent = 'Copy failed';
          message.classList.add('is-visible');

          window.setTimeout(() => {
            message.classList.remove('is-visible');
            message.textContent = '';
            button.classList.remove('has-message');

            if (label) {
              label.textContent = defaultLabel;
            }
          }, 1800);
        }
      }
    });

    showDiscountConfirmation();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var isOpen = false;
    var lastFocused = null;

    function setOpen(open) {
      isOpen = open;
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) {
        drawer.removeAttribute('inert');
        document.body.classList.add('cart-drawer-open');
        lastFocused = document.activeElement;
        // Move focus into the drawer for keyboard users
        var closeBtn = drawer.querySelector('[data-cart-close]');
        if (closeBtn) closeBtn.focus();
      } else {
        drawer.setAttribute('inert', '');
        document.body.classList.remove('cart-drawer-open');
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }
    }

    // Delegated: anything with [data-cart-toggle] opens the drawer.
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-cart-toggle]');
      if (toggle) {
        // Honor modifier clicks (open in new tab, etc.) by NOT intercepting them.
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
        event.preventDefault();
        setOpen(true);
      }
    });

    // Delegated close (close button, backdrop, continue-shopping, thumbnail nav)
    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-backdrop]')) {
        setOpen(false);
        return;
      }
      var closer = event.target.closest('[data-cart-close]');
      if (!closer) return;
      // If the closer is a link (e.g. product thumb), let navigation proceed
      // and close the drawer afterwards so back-button returns cleanly.
      if (closer.tagName === 'A') {
        setOpen(false);
        return;
      }
      event.preventDefault();
      setOpen(false);
    });

    // Escape to close
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen) {
        event.stopPropagation();
        setOpen(false);
      }
    });

    // --- AJAX cart mutations ------------------------------------------------
    var changeUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'cart/change.js'
      : '/cart/change.js';

    function setLoading(loading) {
      drawer.classList.toggle('is-loading', loading);
    }

    function updateHeaderBadge(count) {
      var cartLinks = document.querySelectorAll('[data-cart-toggle]');
      cartLinks.forEach(function (link) {
        var badge = link.querySelector('.site-header__cart-count');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'site-header__cart-count';
            link.prepend(badge);
          }
          badge.textContent = count;
        } else if (badge) {
          badge.remove();
        }
      });
    }

    function refresh() {
      // Fetch a fresh render of this section and swap in the panel contents.
      var url = window.location.pathname + '?section_id=cart-drawer';
      return fetch(url, { credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer-content]');
          var current = drawer.querySelector('[data-cart-drawer-content]');
          if (fresh && current) {
            current.innerHTML = fresh.innerHTML;
          }
          // Re-read empty state from the refreshed root (the section wrapper
          // above this element carries the is-empty class).
          var freshRoot = doc.querySelector('[data-cart-drawer]');
          if (freshRoot) {
            drawer.classList.toggle('is-empty', freshRoot.classList.contains('is-empty'));
          }
        })
        .then(function () {
          // Update header badge from the source of truth.
          return fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (cart) { updateHeaderBadge(cart.item_count); });
        });
    }

    function changeLine(line, quantity) {
      setLoading(true);
      return fetch(changeUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ line: line, quantity: quantity }),
      })
        .then(function () { return refresh(); })
        .catch(function (err) { console.error('Cart update failed', err); })
        .then(function () { setLoading(false); });
    }

    // Delegated quantity + remove handlers. Re-bound via delegation so they
    // keep working after the drawer content is replaced by refresh().
    drawer.addEventListener('click', function (event) {
      var qtyBtn = event.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        event.preventDefault();
        var line = qtyBtn.closest('[data-cart-line]');
        if (!line) return;
        var current = parseInt(line.getAttribute('data-quantity'), 10) || 0;
        var action = qtyBtn.getAttribute('data-cart-qty');
        var next = action === 'plus' ? current + 1 : Math.max(0, current - 1);
        changeLine(parseInt(line.getAttribute('data-cart-line'), 10), next);
        return;
      }

      var removeBtn = event.target.closest('[data-cart-remove]');
      if (removeBtn) {
        event.preventDefault();
        var lineEl = removeBtn.closest('[data-cart-line]');
        if (!lineEl) return;
        changeLine(parseInt(lineEl.getAttribute('data-cart-line'), 10), 0);
      }
    });

    // --- Toast (transient error / status messages) -------------------------
    var toast = document.querySelector('[data-cart-toast]');
    var toastMessage = toast ? toast.querySelector('[data-cart-toast-message]') : null;
    var toastCloseBtn = toast ? toast.querySelector('[data-cart-toast-close]') : null;
    var toastTimer = null;

    function hideToast() {
      if (!toast) return;
      toast.classList.remove('is-visible');
      // Wait for transition before fully hiding so screen readers don't re-read.
      window.setTimeout(function () {
        if (!toast.classList.contains('is-visible')) toast.hidden = true;
      }, 360);
    }

    function showToast(message, options) {
      if (!toast || !toastMessage) return;
      if (toastTimer) window.clearTimeout(toastTimer);
      toastMessage.textContent = message || 'Something went wrong.';
      toast.hidden = false;
      // Force a reflow so the transition runs on the next frame.
      // eslint-disable-next-line no-unused-expressions
      toast.offsetHeight;
      toast.classList.add('is-visible');
      var duration = options && typeof options.duration === 'number' ? options.duration : 5000;
      if (duration > 0) {
        toastTimer = window.setTimeout(hideToast, duration);
      }
    }

    if (toastCloseBtn) {
      toastCloseBtn.addEventListener('click', hideToast);
    }

    // Public API so product-page add-to-cart code (or any custom JS) can
    // trigger a refresh + open without reaching into internals.
    window.ChewlosophyCart = {
      open: function () { setOpen(true); },
      close: function () { setOpen(false); },
      refresh: refresh,
      openAfterAdd: function () {
        return refresh().then(function () { setOpen(true); });
      },
      notify: showToast,
    };

    // Also listen for a generic cart-update event (future add-to-cart hook).
    document.addEventListener('cart:updated', function () {
      refresh().then(function () { setOpen(true); });
    });

    // --- Add-to-cart interception ------------------------------------------
    // Any form that posts to /cart/add gets routed through /cart/add.js and
    // then pops the drawer open. Matches Shopify product forms,
    // which renders action="/cart/add" (or a locale-prefixed variant).
    // Unrelated forms are ignored.
    var addUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js';

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;

      // Match /cart/add and locale-prefixed variants like /en-us/cart/add.
      var action = form.getAttribute('action') || '';
      if (!/\/cart\/add(?:\.js)?$/.test(action)) return;

      // Skip if some other handler has already taken over (e.g. dynamic
      // checkout buttons that set their own submitter flow).
      if (event.defaultPrevented) return;

      event.preventDefault();

      var submitBtn = event.submitter
        || form.querySelector('[type="submit"]:not([formnovalidate])');
      if (submitBtn) submitBtn.setAttribute('disabled', '');
      form.classList.add('is-submitting');

      var formData = new FormData(form);

      fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      })
        .then(function (res) {
          return res.json().then(function (json) {
            if (!res.ok) {
              var err = new Error((json && (json.description || json.message)) || 'Add to cart failed');
              err.response = json;
              throw err;
            }
            return json;
          });
        })
        .then(function () {
          return window.ChewlosophyCart.openAfterAdd();
        })
        .catch(function (err) {
          console.error('Add to cart failed:', err);
          var message = err && err.message ? err.message : 'Sorry, we could not add that item.';
          // Primary: toast — always visible, no form markup required.
          showToast(message);
          // Secondary: if the form provides an inline error slot, fill it too.
          var errorSlot = form.querySelector('[data-cart-add-error]');
          if (errorSlot) {
            errorSlot.textContent = message;
            errorSlot.hidden = false;
          }
        })
        .then(function () {
          if (submitBtn) submitBtn.removeAttribute('disabled');
          form.classList.remove('is-submitting');
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var toggle = header.querySelector('.site-header__toggle');
    var drawer = header.querySelector('[data-site-header-drawer]');

    function setOpen(open) {
      if (!toggle || !drawer) return;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      drawer.classList.toggle('is-open', open);
      if (open) {
        drawer.removeAttribute('inert');
      } else {
        drawer.setAttribute('inert', '');
      }
      document.body.classList.toggle('site-header-drawer-open', open);
    }

    if (toggle && drawer) {
      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        setOpen(!isOpen);
      });

      // Close on link tap (before navigation commits, keeps state clean on SPAs / back button)
      drawer.addEventListener('click', function (event) {
        if (event.target.closest('a')) setOpen(false);
      });

      // Close if viewport grows back past the mobile breakpoint
      var mq = window.matchMedia('(min-width: 981px)');
      var handleMq = function (e) {
        if (e.matches) setOpen(false);
      };
      if (mq.addEventListener) {
        mq.addEventListener('change', handleMq);
      } else if (mq.addListener) {
        mq.addListener(handleMq);
      }
    }

    var searchToggle = header.querySelector('[data-search-toggle]');
    var searchOverlay = header.querySelector('[data-site-search]');
    var searchInput = header.querySelector('[data-search-input]');
    var searchForm = header.querySelector('[data-search-form]');
    var searchResults = header.querySelector('[data-search-results]');
    var searchEmpty = header.querySelector('[data-search-empty]');
    var searchLoading = header.querySelector('[data-search-loading]');
    var searchBody = header.querySelector('[data-search-body]');
    var searchUrl = searchOverlay ? searchOverlay.getAttribute('data-search-url') || '/search' : '/search';
    var searchAbort = null;
    var searchTimer = null;

    function escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, function (char) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }[char];
      });
    }

    function resultImage(item) {
      if (!item || !item.image) return '';
      if (typeof item.image === 'string') return item.image;
      return item.image.url || item.image.src || '';
    }

    function resultMeta(type, item) {
      if (type === 'products') {
        if (!item.price || item.price === '0.00' || item.price === '$0.00') return 'Product';
        return item.price;
      }
      if (type === 'articles') return 'Article';
      return 'Page';
    }

    function renderSearchResults(query, resources) {
      var groups = [
        { key: 'products', label: 'Products' },
        { key: 'pages', label: 'Pages' },
        { key: 'articles', label: 'Articles' }
      ];
      var html = '';
      var total = 0;

      groups.forEach(function (group) {
        var items = resources[group.key] || [];
        if (!items.length) return;
        total += items.length;
        html += '<section class="site-search__group">';
        html += '<h3 class="site-search__group-title">' + group.label + '</h3>';
        html += '<div class="site-search__items">';
        items.forEach(function (item) {
          var image = resultImage(item);
          html += '<a class="site-search__item" href="' + escapeHtml(item.url) + '">';
          if (image) {
            html += '<span class="site-search__thumb" style="background-image:url(' + escapeHtml(image) + ');"></span>';
          } else {
            html += '<span class="site-search__thumb site-search__thumb--empty">+</span>';
          }
          html += '<span>';
          html += '<span class="site-search__item-title">' + escapeHtml(item.title) + '</span>';
          html += '<span class="site-search__item-meta">' + escapeHtml(resultMeta(group.key, item)) + '</span>';
          html += '</span>';
          html += '</a>';
        });
        html += '</div></section>';
      });

      if (!total) {
        searchResults.innerHTML = '<div class="site-search__message">No results for "' + escapeHtml(query) + '".</div>';
      } else {
        searchResults.innerHTML = html + '<a class="site-search__view-all" href="' + escapeHtml(searchUrl) + '?q=' + encodeURIComponent(query) + '">View all results</a>';
      }
    }

    function runSearch(query) {
      if (!searchResults || !searchEmpty || !searchLoading) return;
      if (searchAbort) searchAbort.abort();

      query = query.trim();
      if (query.length < 2) {
        searchResults.innerHTML = '';
        searchEmpty.hidden = false;
        searchLoading.hidden = true;
        return;
      }

      searchEmpty.hidden = true;
      searchLoading.hidden = false;
      searchAbort = new AbortController();

      fetch(searchUrl + '/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,page,article&resources[limit]=5&resources[options][unavailable_products]=last', {
        signal: searchAbort.signal,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Search failed');
          return response.json();
        })
        .then(function (data) {
          searchLoading.hidden = true;
          renderSearchResults(query, data.resources && data.resources.results ? data.resources.results : {});
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          searchLoading.hidden = true;
          searchResults.innerHTML = '<div class="site-search__message">Search is unavailable right now.</div>';
        });
    }

    function setSearchOpen(open) {
      if (!searchToggle || !searchOverlay) return;
      searchOverlay.classList.toggle('is-open', open);
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('site-search-open', open);
      if (open) {
        setOpen(false);
        searchOverlay.removeAttribute('inert');
        window.setTimeout(function () {
          if (searchInput) searchInput.focus();
        }, 80);
      } else {
        searchOverlay.setAttribute('inert', '');
        if (searchAbort) searchAbort.abort();
      }
    }

    if (searchToggle && searchOverlay) {
      searchToggle.addEventListener('click', function () {
        setSearchOpen(true);
      });

      header.addEventListener('click', function (event) {
        if (event.target.closest('[data-search-close]')) {
          setSearchOpen(false);
          searchToggle.focus();
        }
      });

      if (searchInput) {
        searchInput.addEventListener('input', function () {
          window.clearTimeout(searchTimer);
          searchTimer = window.setTimeout(function () {
            runSearch(searchInput.value);
          }, 180);
        });
      }

      if (searchForm) {
        searchForm.addEventListener('submit', function (event) {
          if (!searchInput || searchInput.value.trim() === '') {
            event.preventDefault();
            searchInput.focus();
          }
        });
      }

      if (searchBody) {
        searchBody.addEventListener('click', function (event) {
          if (event.target.closest('a')) setSearchOpen(false);
        });
      }
    }

    // Close on ESC
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (searchOverlay && searchOverlay.classList.contains('is-open')) {
        setSearchOpen(false);
        if (searchToggle) searchToggle.focus();
        return;
      }
      if (toggle && toggle.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
        toggle.focus();
      }
    });

    // Track scroll to shrink the pink corner once the user leaves the top
    // of the page. Only relevant when the header is sticky — otherwise the
    // header scrolls off anyway and there's nothing to shrink.
    if (header.classList.contains('site-header--sticky')) {
      var scrolledThreshold = 40;
      var isScrolled = false;
      var ticking = false;

      var updateScrollState = function () {
        var shouldBeScrolled = window.scrollY > scrolledThreshold;
        if (shouldBeScrolled !== isScrolled) {
          isScrolled = shouldBeScrolled;
          header.classList.toggle('is-scrolled', isScrolled);
        }
        ticking = false;
      };

      window.addEventListener(
        'scroll',
        function () {
          if (!ticking) {
            window.requestAnimationFrame(updateScrollState);
            ticking = true;
          }
        },
        { passive: true }
      );

      // Initial state covers refresh-while-scrolled and back-nav restoration.
      updateScrollState();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-flavors"] && !Shopify.designMode) return;
  try {
    
  (function initFlavorsSlider() {
    const sliders = document.querySelectorAll('[data-flavors-slider]');
    if (!sliders.length) return;

    sliders.forEach(function (slider) {
      const track = slider.querySelector('[data-flavors-track]');
      const prev = slider.querySelector('[data-flavors-prev]');
      const next = slider.querySelector('[data-flavors-next]');
      if (!track || !prev || !next) return;

      function step() {
        const card = track.querySelector('.home-flavors__card');
        if (!card) return track.clientWidth * 0.8;
        const cardRect = card.getBoundingClientRect();
        const grid = track.querySelector('.home-flavors__grid');
        const gap = grid ? parseFloat(getComputedStyle(grid).gap) || 0 : 0;
        return cardRect.width + gap;
      }

      function updateButtons() {
        // Tolerance absorbs sub-pixel and scroll-snap-induced offsets so
        // the start/end states don't flicker off by a few pixels.
        const EDGE_TOLERANCE = 8;
        const maxScroll = track.scrollWidth - track.clientWidth;
        const atStart = track.scrollLeft <= EDGE_TOLERANCE;
        const atEnd = track.scrollLeft >= maxScroll - EDGE_TOLERANCE;
        prev.disabled = atStart;
        next.disabled = atEnd;
        track.classList.toggle('is-at-start', atStart);
        track.classList.toggle('is-at-end', atEnd);
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      // Re-check once images/fonts settle (they can shift scrollWidth).
      window.addEventListener('load', updateButtons);
      // Reset in case the browser restored a previous scroll position, then
      // wait a frame so layout is fully settled before reading scrollLeft.
      track.scrollLeft = 0;
      requestAnimationFrame(updateButtons);
    });

    // Theme editor integration: when a merchant clicks a flavor card block in
    // the Shopify admin sidebar, scroll that card into the slider's view so
    // the selection outline is visible. Gated on designMode so this is a
    // no-op on the live storefront.
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (event) {
        var card = event.target && event.target.closest
          ? event.target.closest('.home-flavors__card')
          : null;
        if (!card) return;
        card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"] && !Shopify.designMode) return;
  try {
    
  class ContactPhoneMask {
    constructor(input) {
      this.input = input;
      this.input.addEventListener('input', this.handleInput.bind(this));
      this.input.addEventListener('blur', this.handleBlur.bind(this));
      this.formatCurrentValue();
    }

    getDigits() {
      return this.input.value.replace(/\D/g, '').slice(0, 10);
    }

    format(digits) {
      if (digits.length === 0) {
        return '';
      }

      if (digits.length < 4) {
        return `(${digits}`;
      }

      if (digits.length < 7) {
        return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
      }

      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }

    formatCurrentValue() {
      this.input.value = this.format(this.getDigits());
    }

    handleInput() {
      this.formatCurrentValue();
      this.validate();
    }

    handleBlur() {
      this.validate();
      this.formatCurrentValue();
    }

    validate() {
      if (this.getDigits().length === 0) {
        this.input.setCustomValidity('');
        return;
      }

      if (this.getDigits().length !== 10) {
        this.input.setCustomValidity('Enter a 10-digit phone number.');
        return;
      }

      this.input.setCustomValidity('');
    }
  }

  document.querySelectorAll('[data-phone-mask]').forEach((input) => {
    new ContactPhoneMask(input);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function formatMoney(cents) {
      var amount = (Number(cents) || 0) / 100;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(amount);
    }

    function productDetailHighResImageUrl(url) {
      if (!url) return '';
      return url.replace(/([?&])width=\d+/, '$1width=1800');
    }

    function productDetailSetImageSource(root, url, mediaId) {
      var mainImage = root.querySelector('.product-detail__main-image');
      var zoomImage = root.querySelector('.product-detail__zoom-image');
      if (!mainImage || !url) return;
      mainImage.setAttribute('src', url);
      mainImage.removeAttribute('srcset');
      if (zoomImage) {
        // Don't download the 1800px version on every variant change — only
        // remember it, and load it when the zoom is actually opened.
        zoomImage.setAttribute('data-pending-src', productDetailHighResImageUrl(url));
        zoomImage.removeAttribute('srcset');
      }
      root.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === String(mediaId));
      });
    }

    function productDetailUpdateMainImage(root, url, mediaId) {
      var mainImage = root.querySelector('.product-detail__main-image');
      var mainStage = root.querySelector('.product-detail__stage');
      if (!mainImage || !url) return;
      if (mainImage.getAttribute('src') === url) return; // already showing it
      if (!mainStage || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        productDetailSetImageSource(root, url, mediaId);
        return;
      }

      // Decode the new image BEFORE swapping, instead of waiting a fixed 160ms.
      // This removes the artificial delay and prevents a blank/flashing stage.
      var pre = new Image();
      pre.src = url;

      // Only show the loading animation if the image isn't ready almost
      // immediately — avoids a flicker when it's already cached.
      var loadingTimer = window.setTimeout(function () {
        mainStage.classList.add('is-changing');
      }, 120);

      var swap = function () {
        window.clearTimeout(loadingTimer);
        productDetailSetImageSource(root, url, mediaId);
        mainStage.classList.remove('is-changing');
        mainStage.classList.add('is-entering');
        window.setTimeout(function () {
          mainStage.classList.remove('is-entering');
        }, 320);
      };
      var done = false;
      var runOnce = function () { if (!done) { done = true; swap(); } };
      if (pre.decode) {
        pre.decode().then(runOnce).catch(runOnce);
      } else {
        pre.onload = runOnce;
        pre.onerror = runOnce;
      }
      window.setTimeout(runOnce, 700); // safety net if decode stalls
    }

    function productDetailSetZoomOpen(root, open) {
      var zoom = root.querySelector('[data-product-zoom]');
      if (!zoom) return;
      if (open) {
        var zi = root.querySelector('.product-detail__zoom-image');
        var pending = zi && zi.getAttribute('data-pending-src');
        if (pending) {
          zi.setAttribute('src', pending);
          zi.removeAttribute('data-pending-src');
        }
      }
      zoom.classList.toggle('is-open', open);
      document.body.classList.toggle('product-zoom-open', open);
      if (open) {
        zoom.removeAttribute('inert');
      } else {
        zoom.setAttribute('inert', '');
      }
    }

    window.ChewProductDetail = {
      selectImage: function (button) {
        var root = button && button.closest ? button.closest('[data-product-detail]') : null;
        if (!root) return true;
        productDetailUpdateMainImage(root, button.getAttribute('data-full-image'), button.getAttribute('data-media-id'));
        return false;
      },
      openZoom: function (button) {
        var root = button && button.closest ? button.closest('[data-product-detail]') : null;
        if (!root) return true;
        productDetailSetZoomOpen(root, true);
        return false;
      },
      closeZoom: function (button) {
        var root = button && button.closest ? button.closest('[data-product-detail]') : null;
        if (!root) return true;
        productDetailSetZoomOpen(root, false);
        return false;
      }
    };

    function bindProductDetailDelegates() {
      if (window.__chewProductDetailDelegatesBound) return;
      window.__chewProductDetailDelegatesBound = true;

      document.addEventListener('click', function (event) {
        var target = event.target;
        if (!target || !target.closest) return;

        var root = target.closest('[data-product-detail]');
        if (!root) return;

        var thumb = target.closest('[data-product-thumb]');
        if (thumb && root.contains(thumb)) {
          event.preventDefault();
          productDetailUpdateMainImage(root, thumb.getAttribute('data-full-image'), thumb.getAttribute('data-media-id'));
          return;
        }

        var closeButton = target.closest('[data-product-zoom-close]');
        if (closeButton && root.contains(closeButton)) {
          event.preventDefault();
          productDetailSetZoomOpen(root, false);
          return;
        }

        var zoomButton = target.closest('[data-product-zoom-open]');
        if (zoomButton && root.contains(zoomButton)) {
          event.preventDefault();
          productDetailSetZoomOpen(root, true);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        document.querySelectorAll('[data-product-detail]').forEach(function (root) {
          productDetailSetZoomOpen(root, false);
        });
      });

      document.addEventListener('pointermove', function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        var stage = target.closest('[data-product-zoom-open]');
        if (!stage) return;
        var rect = stage.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        var x = ((event.clientX - rect.left) / rect.width) * 100;
        var y = ((event.clientY - rect.top) / rect.height) * 100;
        stage.style.setProperty('--product-zoom-x', Math.max(0, Math.min(100, x)) + '%');
        stage.style.setProperty('--product-zoom-y', Math.max(0, Math.min(100, y)) + '%');
      });

      document.addEventListener('pointerout', function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        var stage = target.closest('[data-product-zoom-open]');
        if (!stage) return;
        if (event.relatedTarget && stage.contains(event.relatedTarget)) return;
        stage.style.setProperty('--product-zoom-x', '50%');
        stage.style.setProperty('--product-zoom-y', '50%');
      });
    }

    function initProductDetails() {
      document.querySelectorAll('[data-product-detail]').forEach(function (root) {
        if (root.hasAttribute('data-product-ready')) return;

        var mainImage = root.querySelector('.product-detail__main-image');
        var mainStage = root.querySelector('.product-detail__stage');
        var zoom = root.querySelector('[data-product-zoom]');
        var zoomImage = root.querySelector('.product-detail__zoom-image');
        var thumbs = root.querySelectorAll('[data-product-thumb]');
        var form = root.querySelector('[data-product-form]');
        var variantInput = root.querySelector('[data-variant-id]');
        var optionInputs = root.querySelectorAll('[data-option-input]');
        var price = root.querySelector('[data-product-price]');
        var compare = root.querySelector('[data-product-compare]');
        var badge = root.querySelector('[data-product-badge]');
        var addButton = root.querySelector('[data-add-to-cart]');
        var quantity = root.querySelector('[name="quantity"]');
        var minus = root.querySelector('[data-qty-minus]');
        var plus = root.querySelector('[data-qty-plus]');
        var share = root.querySelector('[data-product-share]');
        var product = null;
        root.setAttribute('data-product-ready', '');

        function selectedOptions() {
          var values = [];
          root.querySelectorAll('.product-detail__option').forEach(function (fieldset) {
            var checked = fieldset.querySelector('[data-option-input]:checked');
            values.push(checked ? checked.value : '');
          });
          return values;
        }

        function selectedVariant() {
          if (!product) return null;
          var options = selectedOptions();
          return product.variants.find(function (variant) {
            return variant.options.every(function (value, index) {
              return value === options[index];
            });
          });
        }

        function variantMatchesOptionSet(variant, candidateOptions) {
          return variant.options.every(function (value, index) {
            return !candidateOptions[index] || value === candidateOptions[index];
          });
        }

       
         function updateOptionAvailability() {
          if (!product) return;
          var currentOptions = selectedOptions();

          optionInputs.forEach(function (input) {
            var fieldset = input.closest('.product-detail__option');
            var optionIndex = fieldset ? Number(fieldset.getAttribute('data-option-index')) : -1;
            if (optionIndex < 0) return;

            var candidateOptions = currentOptions.slice();
            candidateOptions[optionIndex] = input.value;
            var hasAvailableVariant = product.variants.some(function (variant) {
              return variant.available && variantMatchesOptionSet(variant, candidateOptions);
            });

            input.disabled = !hasAvailableVariant;
          });
        }



        function mediaForVariant(variant) {
          if (!product || !variant || !variant.featured_media) return null;
          return product.media.find(function (media) {
            return media.id === variant.featured_media.id;
          });
        }

        function normalizeText(value) {
          return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
        }

        function mediaForSelectedOptions(variant) {
          if (!product || !variant) return null;
          var candidates = variant.options.map(normalizeText).filter(Boolean);
          return product.media.find(function (media) {
            var src = normalizeText(media.src || (media.preview_image && media.preview_image.src));
            var alt = normalizeText(media.alt);
            return candidates.some(function (option) {
              return src.indexOf(option) !== -1 || alt.indexOf(option) !== -1;
            });
          }) || null;
        }

        function setImageSource(url, mediaId) {
          if (!mainImage || !url) return;
          mainImage.setAttribute('src', url);
          mainImage.removeAttribute('srcset');
          if (zoomImage) {
            zoomImage.setAttribute('src', productDetailHighResImageUrl(url));
            zoomImage.removeAttribute('srcset');
          }
          thumbs.forEach(function (thumb) {
            thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === String(mediaId));
          });
        }

        function updateMainImage(url, mediaId) {
          if (!mainImage || !url) return;
          if (!mainStage || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            setImageSource(url, mediaId);
            return;
          }

          mainStage.classList.add('is-changing');
          window.setTimeout(function () {
            setImageSource(url, mediaId);
            mainStage.classList.remove('is-changing');
            mainStage.classList.add('is-entering');
            window.setTimeout(function () {
              mainStage.classList.remove('is-entering');
            }, 300);
          }, 160);
        }

        function setZoomOpen(open) {
          if (!zoom) return;
          zoom.classList.toggle('is-open', open);
          document.body.classList.toggle('product-zoom-open', open);
          if (open) {
            zoom.removeAttribute('inert');
          } else {
            zoom.setAttribute('inert', '');
          }
        }

        var jsonNode = root.querySelector('[data-product-json]');
        if (jsonNode) {
          try {
            product = JSON.parse(jsonNode.textContent);
          } catch (error) {
            product = null;
          }
        }

        /* ===== BEGIN dependent-options: Packs depend on Size — remove or edit later ===== */
        // Links two options by their legend text. Rename these if you rename the
        // options in the admin. Matching is case-insensitive / partial.
        var DEP_CONTROLLER_NAME = 'size';   // drives the cascade
        var DEP_DEPENDENT_NAME  = 'packs';  // gets filtered by the controller

        var depControllerField = null;
        var depDependentField = null;
        root.querySelectorAll('.product-detail__option').forEach(function (field) {
          var legend = field.querySelector('legend');
          var name = legend ? legend.textContent.trim().toLowerCase() : '';
          if (name.indexOf(DEP_CONTROLLER_NAME) !== -1) depControllerField = field;
          if (name.indexOf(DEP_DEPENDENT_NAME) !== -1) depDependentField = field;
        });

        // Map controller value -> { valid dependent value: true }, based on which
        // combinations EXIST (ignores stock, so it still works while sold out).
        var depMap = {};
        if (product && depControllerField && depDependentField) {
          var depCIdx = Number(depControllerField.getAttribute('data-option-index'));
          var depDIdx = Number(depDependentField.getAttribute('data-option-index'));
          product.variants.forEach(function (v) {
            var c = v.options[depCIdx];
            var d = v.options[depDIdx];
            (depMap[c] = depMap[c] || {})[d] = true;
          });
        }

        function updateDependentOptions() {
          if (!depControllerField || !depDependentField) return;
          var controllerInput = depControllerField.querySelector('[data-option-input]:checked');
          if (!controllerInput) return;
          var valid = depMap[controllerInput.value] || {};
          var depInputs = depDependentField.querySelectorAll('[data-option-input]');
          var checkedInvalid = false;
          var firstValid = null;

          depInputs.forEach(function (input) {
            var ok = !!valid[input.value];
            var label = input.nextElementSibling; // the <label> right after the input
            input.style.display = ok ? '' : 'none';
            if (label) label.style.display = ok ? '' : 'none';
            if (ok && !firstValid) firstValid = input;
            if (input.checked && !ok) checkedInvalid = true;
          });

          // If the current Packs value doesn't exist for the chosen Size, snap to
          // the first valid one so price and the selected variant stay correct.
          if (checkedInvalid && firstValid) {
            depInputs.forEach(function (i) { i.checked = false; });
            firstValid.checked = true;
          }
        }
        /* ===== END dependent-options ===== */

        /* ===== BEGIN variant-gallery: multiple images per variant via metafield — remove or edit later ===== */
        var galleryMap = {};
        var galleryNode = root.querySelector('[data-variant-gallery]');
        if (galleryNode) {
          try { galleryMap = JSON.parse(galleryNode.textContent); } catch (e) { galleryMap = {}; }
        }
        var galleryHasData = galleryMap && Object.keys(galleryMap).length > 0;

        var mfMediaWrap = root.querySelector('.product-detail__media');
        var mfThumbsExisted = !!root.querySelector('.product-detail__thumbs');
        var mfOriginalThumbsHTML = mfThumbsExisted
          ? root.querySelector('.product-detail__thumbs').innerHTML
          : null;

        function mfEnsureThumbs() {
          var c = root.querySelector('.product-detail__thumbs');
          if (!c && mfMediaWrap) {
            c = document.createElement('div');
            c.className = 'product-detail__thumbs';
            c.setAttribute('aria-label', 'Product media');
            mfMediaWrap.appendChild(c);
          }
          return c;
        }

        function mfRenderThumbs(items) {
          var c = mfEnsureThumbs();
          if (!c) return;
          c.innerHTML = items.map(function (it, i) {
            var alt = String(it.alt || '').replace(/"/g, '&quot;');
            return '<button type="button" class="product-detail__thumb' + (i === 0 ? ' is-active' : '') +
              '" data-product-thumb data-full-image="' + it.full + '" data-media-id="mf-' + i + '">' +
              '<img src="' + it.thumb + '" alt="' + alt + '" loading="lazy" width="90" height="90"></button>';
          }).join('');
          c.setAttribute('data-mf', '1');
          c.style.display = '';
        }

        function mfRevertThumbs() {
          var c = root.querySelector('.product-detail__thumbs');
          if (!c || c.getAttribute('data-mf') !== '1') return;
          if (mfThumbsExisted && mfOriginalThumbsHTML !== null) {
            c.innerHTML = mfOriginalThumbsHTML;
            c.removeAttribute('data-mf');
          } else {
            c.innerHTML = '';
            c.style.display = 'none';
            c.removeAttribute('data-mf');
          }
        }

        // Returns true if it swapped in the variant's metafield images.
        function applyVariantGallery(variant) {
          if (!galleryHasData || !variant) return false;
          var items = galleryMap[variant.id];
          if (items && items.length) {
            mfRenderThumbs(items);
            productDetailUpdateMainImage(root, items[0].full, 'mf-0');
            return true;
          }
          mfRevertThumbs();
          return false;
        }

        // Warm the cache for other variants' first images during idle time, so
        // switching variants doesn't wait on a fresh network request.
        function mfPrefetch() {
          var urls = [];
          Object.keys(galleryMap).forEach(function (k) {
            var list = galleryMap[k];
            if (list && list[0] && list[0].full) urls.push(list[0].full);
          });
          var i = 0;
          function next() {
            if (i >= urls.length) return;
            var img = new Image();
            img.src = urls[i++];
            img.onload = img.onerror = function () { window.setTimeout(next, 60); };
          }
          next();
        }
        if (galleryHasData) {
          if (window.requestIdleCallback) {
            window.requestIdleCallback(mfPrefetch, { timeout: 3000 });
          } else {
            window.setTimeout(mfPrefetch, 1500);
          }
        }
        /* ===== END variant-gallery ===== */

        function updateProductState() {
          updateDependentOptions(); // dependent-options — remove with the fenced block above
          updateOptionAvailability();

          var variant = selectedVariant();
          if (!variant) {
            if (!product) return;
            if (addButton) {
              addButton.textContent = 'Unavailable';
              addButton.setAttribute('disabled', '');
            }
            if (badge) badge.textContent = 'Unavailable';
            return;
          }

          if (variantInput) variantInput.value = variant.id;
          if (price) price.textContent = formatMoney(variant.price);

          if (compare) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              compare.textContent = formatMoney(variant.compare_at_price);
              compare.hidden = false;
            } else {
              compare.hidden = true;
            }
          }

          if (badge) badge.textContent = variant.available ? 'In stock' : 'COMING SOON';
          if (addButton) {
            addButton.textContent = variant.available ? 'Add to cart' : 'COMING SOON';
            if (variant.available) {
              addButton.removeAttribute('disabled');
            } else {
              addButton.setAttribute('disabled', '');
            }
          }

          if (!applyVariantGallery(variant)) { // variant-gallery — remove with the fenced block above
            var media = mediaForVariant(variant) || mediaForSelectedOptions(variant);
            if (media && media.src) productDetailUpdateMainImage(root, media.src, media.id);
          }

          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

        optionInputs.forEach(function (input) {
          input.addEventListener('change', updateProductState);
        });

        if (minus && quantity) {
          minus.addEventListener('click', function () {
            var next = Math.max(1, (parseInt(quantity.value, 10) || 1) - 1);
            quantity.value = next;
          });
        }

        if (plus && quantity) {
          plus.addEventListener('click', function () {
            quantity.value = (parseInt(quantity.value, 10) || 1) + 1;
          });
        }

        if (share) {
          share.addEventListener('click', function () {
            if (navigator.share) {
              navigator.share({ title: document.title, url: window.location.href }).catch(function () {});
            } else if (navigator.clipboard) {
              navigator.clipboard.writeText(window.location.href);
              share.textContent = 'Link copied';
              window.setTimeout(function () { share.textContent = 'Share'; }, 1800);
            }
          });
        }

        if (form) {
          form.addEventListener('change', function () {
            var error = form.querySelector('[data-cart-add-error]');
            if (error) error.hidden = true;
          });
        }

        updateProductState();
      });
    }

    bindProductDetailDelegates();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductDetails);
    } else {
      initProductDetails();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
